var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.productFrames),function(quantity,key){return _c('input',{key:key,attrs:{"name":_vm.productFrameName(key),"type":"hidden"},domProps:{"value":quantity}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543ce871","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/default/catalog-mix/components/PhotoSelection/FormInputs.vue
// module id = 1418
// module chunks = 2